// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1z4t8","detailsBorder":"styles_detailsBorder__3OuPA"};